import React, { useMemo } from 'react'
import { observer } from 'mobx-react'
import { useHistoryNew } from '@utils'
import { Icon } from '@cps'
import { cartMobx } from 'restaurant'
import { thirdPartyMobx } from '@mobxStore'

const ThirdCouponBar: React.FC = () => {
  const history = useHistoryNew()

  const handleGoThird = () => {
    history.push('/thirdCoupon')
  }

  // 是否支持核券
  const hasThird = useMemo(() => {
    return !!thirdPartyMobx.checkCanUseToChannelEatType
  }, [cartMobx.channel, cartMobx.info.eatType])

  if (!hasThird) return null

  const couponCnt = thirdPartyMobx.checkCoupons.length

  return (
    <div className='waterfall-bt-wrap'>
      <div className='waterfall-coupon-bar-element waterfall-bt-btn' data-cypid='click-third-coupon-bar' onClick={handleGoThird}>
        <div className='bt-icon'>
          <Icon name='thirdcoupon' />
        </div>
        <div className='name'>{`${i18n.t('pay.douyinCoupon')}${couponCnt > 0 ? ` x${couponCnt}` : ''}`}</div>
      </div>
    </div>
  )
}

export default observer(ThirdCouponBar)
